<template>
    <div v-if="constraints.selectables.items">
        <v-select
        :id="field.key" 
        :options="items"
        :required="field.constraints.required"
        v-model="content"
        :taggable="constraints.selectables.custom"
        :multiple="constraints.selectables.multiple"
        ></v-select>
         <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
import VSelect from 'vue-select'

export default {
    name: "IdentityField_SelectNumber",
    components: {
        VSelect
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: Array | Number,
            default: null
        },
        translator: {
            type: Function
        },
        reduce: {
            type: Function,
            default: null
        },
    },
    data: function() {
        return {
            errors: []
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    computed: {
        content: {
            get() {
                if (this.value == null) {
                    this.value = this.constraints.default;
                } 
                
                if (this.constraints.selectables.multiple) {
                    return this.value;
                }

                return this.value;
            },

            set(val) {
                this.check(val);

                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints;

            return constr;
        },
        items() {
            let items = this.constraints.selectables.items;

            return items.sort(function (a, b) {
                return a - b;
            });
        }
    },
    methods: {
        check(val) {
            val = val || []
            this.errors = []

            if (this.constraints.required) {
                if (val == null) {
                    this.errors.push(this.translator("identityField.requiredField"))
                }

                if (this.constraints.selectables.items.indexOf(val) == -1) {
                    this.errors.push(this.translator("identityField.invalidSelection"))
                }
            }

           this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
            
        }
    },
    created() {
        let selectable = this.constraints.selectables

        if (selectable.range.from != 0 && selectable.range.to != 0) {
            for (let i = selectable.range.from; i <= selectable.range.to; i++) {
                if (selectable.items.indexOf(i) == -1) {
                    selectable.items.push(i)
                }
            }
        }

        if (this.constraints.required && (this.constraints.default == "" || this.constraints.default === null)) {
            this.content = selectable.items[0]
        }
    },
    mounted() {
        this.check(this.content)
    }
}
</script>